export const Data = [
  {
    id: "1",
    registrarId: "1234",
    name:"Gara",
    age: 20,
    phone: "0101858401",
    email: "gara.raml@mail.com",
    Address: "Elramla",
    city:"remal city",
    zipCode:"854545",
  },
  {
    id: "2",
    registrarId: "1234",
    name:"Kabato",
    age: 22,
    phone: "0101858402",
    email: "kabato.or@mail.com",
    Address: "ElKheiana ",
    city:"remal city",
    zipCode:"8544",
  },
  {
    id: "3",
    registrarId: "1234",
    name:"Gara",
    age: 30,
    phone: "0101858401",
    email: "gara.raml@mail.com",
    Address: "Elramla",
    city:"remal city",
    zipCode:"854545",
  },
  {
    id: "4",
    registrarId: "1234",
    name:"Gara",
    age: 50,
    phone: "0101858401",
    email: "gara.raml@mail.com",
    Address: "Elramla",
    city:"remal city",
    zipCode:"854545",
  },
  {
    id: "5",
    registrarId: "1234",
    name:"Gara",
    age: 21,
    phone: "0101858401",
    email: "gara.raml@mail.com",
    Address: "Elramla",
    city:"remal city",
    zipCode:"854545",
  },

]